<template>
	<div class="submit1">
		
		<div class="conent"  v-for="(item,index) in info.body" :key="index"  >
			<div class="title">
				<div class="border"></div>
				<div class="name">{{item.info.name}}</div>
				<div class="nanm1">满分{{item.info.fen}} 得分{{item.fen}} 用时{{item.time}}秒</div>
			</div>
			<div class="body ">
				<div class="topic-body-input9" v-if="item.templates.row==9">
					<img class="img-9" :src="item.templates.img" />
					<div class="topic-body-input-div-91">
						<div class="topic-body-input-div-911">
								<div class="topic-body-input-div-9"   v-for="(template,templateIndex) in item.body" :key="templateIndex">
									<div class="topic-body-input-div-div-9" v-for="(templates,templateIndexs) in template" :key="templateIndexs">
									
										<label v-for="(templatess,templateIndexss) in templates" :key="templateIndexss">
											{{templatess.number}}
										</label>
									</div>
								</div>
						</div>
					
					</div>
						
				</div>
				
				<div class="topic-body-input9" v-if="item.templates.row==9">
					<img class="img-9" :src="item.templates.img" />
					<div class="topic-body-input-div-91">
						<div class="topic-body-input-div-911">
							<div class="topic-body-input-div-9" v-for="(template,templateIndex) in item.info.body" :key="templateIndex">
								<div class="topic-body-input-div-div-9" v-for="(templates,templateIndexs) in template" :key="templateIndexs">
									<label v-for="(templatess,templateIndexss) in templates" :key="templateIndexss">
											{{templatess.number}}
									</label>
								</div>
							</div>	
						</div>	
					</div>	
				</div>
				
				<div class="topic-body-input4" v-if="item.templates.row==4">
					
					<img class="img-4" :src="item.templates.img" />
					<div class="topic-body-input-div-41">
						<div class="topic-body-input-div-411">
							<div class="topic-body-input-div-4" :class="templateIndex==2 || templateIndex==5 ? 'as' :''" v-for="(template,templateIndex) in item.body" :key="templateIndex">
								<div class="topic-body-input-div-div-4" v-for="(templates,templateIndexs) in template" :key="templateIndexs">
									<label v-for="(templatess,templateIndexss) in templates" :key="templateIndexss">
											{{templatess.number}}
									</label>
								</div>
							</div>	
						</div>	
					</div>	
				</div>
				
				<div class="topic-body-input4" v-if="item.templates.row==4">
					
					<img class="img-4" :src="item.templates.img" />
					<div class="topic-body-input-div-41">
						<div class="topic-body-input-div-411">
							<div class="topic-body-input-div-4" :class="templateIndex==2 || templateIndex==5 ? 'as' :''" v-for="(template,templateIndex) in item.info.body" :key="templateIndex">
								<div class="topic-body-input-div-div-4" v-for="(templates,templateIndexs) in template" :key="templateIndexs">
									<label v-for="(templatess,templateIndexss) in templates" :key="templateIndexss">
											{{templatess.number}}
									</label>
								</div>
							</div>	
						</div>	
					</div>	
					
				</div>
				
				
				<div class="topic-body-input6" v-if="item.templates.row==6">
					
					<img class="img-6" :src="item.templates.img" />
					<div class="topic-body-input-div-6">
						<div class="topic-body-input-div-61">
							<div class="topic-body-input-div-62" :class="templateIndex==2 || templateIndex==5 ? 'as1' :''" v-for="(template,templateIndex) in item.body" :key="templateIndex">
								<div class="topic-body-input-div-div-6" v-for="(templates,templateIndexs) in template" :key="templateIndexs">
									<label v-for="(templatess,templateIndexss) in templates" :key="templateIndexss">
											{{templatess.number}}
									</label>
								</div>
							</div>	
						</div>	
					</div>	
				</div>
				
				<div class="topic-body-input6" v-if="item.templates.row==6">
					
					<img class="img-6" :src="item.templates.img" />
					<div class="topic-body-input-div-6">
						<div class="topic-body-input-div-61">
							<div class="topic-body-input-div-62" :class="templateIndex==2 || templateIndex==5 ? 'as1' :''" v-for="(template,templateIndex) in item.info.body" :key="templateIndex">
								<div class="topic-body-input-div-div-6" v-for="(templates,templateIndexs) in template" :key="templateIndexs">
									<label v-for="(templatess,templateIndexss) in templates" :key="templateIndexss">
											{{templatess.number}}
									</label>
								</div>
							</div>	
						</div>	
					</div>	
				</div>
				
			</div>
			<div class="top" v-html="item.info.analysis">
			
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		data () {
		  return {
			info : [],
			user : [],
			body : [],
			id   : '',
			classify_id :''
		  };
		},
		created() {
			let that = this;
			var  query = this.$route.query;
			that.id    = query.id;	
			that.classify_id =query.classify_id;
			that.$http('get','/api/v1/question/exercisedetails',{id:query.id,classify_id:query.classify_id}) .then(function (res) {
				that.info = res.data;
				that.body = res.data.body;
				that.body.forEach(item=>{
					console.log(item);
				})
				that.user = res.data.user;
			});	
		},
		methods:{
			GameClick(){
				this.$router.push('/Common');
				
			},
			exercise(){
				let that = this;
				 that.$router.push('./exercise?classify_id='+that.info.classify_id+'&game_id='+that.info.game_id);
					// this.$router.push('/exercise?id='+this.id);
			}
		}
	}
</script>

<style lang="less">
	.topic-body-input9 {
		.img-9 {
			width: 400px;
			height: 400px;
			position: absolute;
			z-index: 1;
			opacity: 0.6;
		}
		.topic-body-input-div-91 {
			z-index: 2;
			width: 400px;
			height: 400px;	
			.topic-body-input-div-911 {
				width: 362px;
				height: 362px;
				margin: auto;
				margin-top: 18px;
				display: flex;
				flex-wrap: wrap;
				border: 1px solid  #000000;
				.topic-body-input-div-9 {
					width: 118.5px;
					height: 118.5px;
					border: 1px solid  #000000;
					display: flex;
					flex-wrap: wrap;
					.topic-body-input-div-div-9 {
						display: flex;
						flex-wrap: wrap;
						width: 118.5px;
						height: 23.6px ;
						label {
							display: block;
							flex: 1;
							line-height: 42.6px;
							text-align: center;
						}
					}
				}
			}
		}
	}
	.topic-body-input4 {
		width: 400px;
		height: 400px;
		.img-4 {
			width: 400px;
			height: 400px;
			position: absolute;
			z-index: 1;
			opacity: 0.6;
		}
		.topic-body-input-div-41 {
			width: 323px;
			height: 320px;
			margin: auto;
			margin-top: 40px;
			display: flex;
			flex-wrap: wrap;
			border: 1px solid #000000;
			.topic-body-input-div-411 {
				display: flex;
				flex-wrap: wrap;
				height:161.5px;
				.topic-body-input-div-4 {
					width: 77.75px;
					height: 158.5px;
					.topic-body-input-div-div-4 {
						width: 77.75px;
						height: 77.75px;
						line-height: 83px;
						text-align: center;
					}
				}
				.as {
					width: 161.5px !important;
					.topic-body-input-div-div-4 {
						width: 161.5px !important;
						display: flex;
						label {
							flex: 1;
							text-align: center;
						}
					}
				}
			}
			
		}
	}
	.topic-body-input6 {
		width: 400px;
		height: 400px;
		.img-6 {
			width: 400px;
			height: 400px;
			position: absolute;
			z-index: 1;
			opacity: 0.6;
		}
		.topic-body-input-div-6{
			width: 341px;
			height: 341px;
			margin: auto;
			margin-top: 29px;
			display: flex;
			flex-wrap: wrap;
			border: 1px solid #000000;
			.topic-body-input-div-61 {
				width: 100%;
				height: 100%;
				display: flex;
				flex-wrap: wrap;
			}
			.topic-body-input-div-62 {
				width: 169.5px;
				height: 113px;	
				.topic-body-input-div-div-6{
					width: 100%;
					height: 56.5px;
					display: flex;
					label {
						text-align: center;
						line-height: 58px;
						flex: 1;
					}
				}
			}
			
		}
		
	}
	
	.submit1 {
		width: 100%;
		
		color: #666666;
		.title {
			margin-top: 10px;
			height: 40px;
			display: flex;
			.border {
				margin-top: 10px;
				margin-left: 30px;
				background-color: #409EFF;
				width: 6px;
				height: 20px;
			}
			.name {
				font-weight: 700;
				padding-left: 10px;
				line-height: 40px;
			}
			.nanm1 {
				padding-left: 10px;
				font-size: 12px;
				line-height: 40px;
			}
		}
		.header {
			width: 100%;
			background-color: #FFFFFF;
			height: 240px;
			border-radius: 10px;
			border: 1px solid rgba(233, 233, 233, 1);
			box-shadow: 0 0 5px #FFF0FF;
			
			.body {
				display: flex;
				margin-top: 10px;
				.div{
					flex: 1;
					border-right: 1px solid rgba(233, 233, 233, 1);
					height: 110px;
					text-align: center;
					img {
						padding-top: 10px;
						width: 70px;
						height: 70px;
					}
					.title {
						padding-top: 20px;
						display: inline-block;
						font-weight: 700;
						font-size: 20px;
						height: 30px;
						text-align: center;
						color: #666666;
						width: 100%;
					}
					span{
						line-height: 0;
						font-size: 12px;
						color: #666666b8;
					}
					
				}
				.div:last-child{
					border: none;
					flex: 3;
					display: flex;
					.left {
						flex: 1;
						border: none;
						button {
							margin-top: 36px;
							background-color: rgba(217, 0, 27, 1);
							span{
								color: #FFFFFF;
							}
							
						}
					}
				}
			}
		}
		.conent {
			margin-top: 30px;
			width: 100%;
			background-color: #FFFFFF;
			min-height: 600px;
			border-radius: 10px;
			border: 1px solid rgba(233, 233, 233, 1);
			box-shadow: 0 0 5px #FFF0FF;
			.body {
				width: 80%;
				margin-left: auto;
				margin-right: auto;
				min-height: 450px;
				border-bottom: 1px solid rgba(233, 233, 233, 1);
				display: flex;
				 flex-wrap: wrap;
			}
			.top {
				padding-top: 15px;
				width: 80%;
				margin-left: auto;
				margin-right: auto;
			}
		}
		
		.topic-body-input {
		    width: 400px;
		    height: 400px;
		    display: flex;
		    flex-wrap: wrap;
		    margin: 10px;
			margin-left: auto;
			margin-right: auto;
		
		}
		.topic-body-input-div {
		    width: 129px;
		    height: 130px;
		    border: 2px solid black;
		}
		
		.topic-body-input-div-div {
		    width: 100%;
		    display: flex;
		}
		.topic-body-input-div-div > input {
		     width: 35px;
		     height: 37.5px;
		     text-align: center;
			 font-weight: 500;
			font-size: 42px;
		}
		.topic-body-input-div-div > label{
			width: 44px;
			height: 43.5px;
		}
		.topic-body-input-div-div > label> input {
			width: 41px;
			height: 41.5px;
			padding: 0;
			font-weight: 500;
			font-size: 49px;
			text-align: center;
			border: none;
			border: 1px solid;
			
			font-family:"方正舒体";
		}
		.avctin {
			background-color: #d9001b !important;
			 opacity:0.2; 
			color: #FFFFFF;
		}
	}
</style>
